import * as React from 'react';
import {Icon as IconMui} from '@mui/material';
import { Media, ThemeTextSize } from '.';
import { textsize } from '../services/app.service';

//https://icons8.com/icons/3d-fluency

interface Props {
  id?: string;
  name: string;
  size?: textsize;
  color?: any;
  marginRight?: boolean;
  noAutoHeight?: boolean;
  rotate?: number;
}

export const Icon: React.FunctionComponent<Props> = (props) => {
  const iconSize = ThemeTextSize(props.size).iconSize;
  const url = props.name.includes('icons8')? `https://img.icons8.com/3d-fluency/500/${props.name.split(':')[1]}.png` : (props.name.includes('assets') || props.name.includes('http')? props.name : '');
  
  return (
    <>
    {url?
      <Media url={url} sx={{height: iconSize, width: props.noAutoHeight? 'auto' : iconSize, mr: props.marginRight? 1 : 0}} />
    : <IconMui id={props.id || props.name} sx={{ fontSize: iconSize, color: props.color, verticalAlign: 'middle', marginRight: props.marginRight? 1 : 0, transform: 'rotate(' +props.rotate+ 'deg)',}}>{props.name.toLowerCase()}</IconMui>
    }
    </>
  )
  
}